import { render, staticRenderFns } from "./EmailsBase.vue?vue&type=template&id=275d1080&"
import script from "./EmailsBase.vue?vue&type=script&lang=js&"
export * from "./EmailsBase.vue?vue&type=script&lang=js&"
import style0 from "./EmailsBase.vue?vue&type=style&index=0&id=275d1080&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports